import {
  KpiConfigState,
  KpiConfigActionTypes,
  FETCH_KPI_CONFIG,
  RESET_KPI_CONFIG,
  SET_KPI_METRIC_GOAL,
  DELETE_KPI_METRIC_GOAL,
  FetchKpiConfigSuccessAction,
  FetchKpiConfigFailureAction,
} from "./KpiConfigTypes";

const initialState: KpiConfigState = {
  config: null,
  isLoading: false,
  isLoaded: false,
  isSavingGoal: false,
  error: null,
};

export const KpiConfigReducer = (
  state = initialState,
  action: KpiConfigActionTypes,
): KpiConfigState => {
  switch (action.type) {
    case FETCH_KPI_CONFIG.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_KPI_CONFIG.SUCCESS:
      const fetchSuccessAction = action as FetchKpiConfigSuccessAction;
      return {
        ...state,
        config: fetchSuccessAction.payload,
        isLoading: false,
        isLoaded: true,
        error: null,
      };

    case FETCH_KPI_CONFIG.FAILURE:
      const fetchFailureAction = action as FetchKpiConfigFailureAction;
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: fetchFailureAction.payload.error,
      };

    case RESET_KPI_CONFIG:
      return initialState;

    case SET_KPI_METRIC_GOAL.REQUEST:
      return {
        ...state,
        isSavingGoal: true,
      };

    case SET_KPI_METRIC_GOAL.FAILURE:
      return {
        ...state,
        isSavingGoal: false,
      };

    case SET_KPI_METRIC_GOAL.SUCCESS:
      const goalMeta = (action as any).meta || {};
      const { kpiMetricId, categoryId, kpiMetricGoal } = goalMeta;
      if (!state.config || !kpiMetricId || !categoryId) {
        return {
          ...state,
          isSavingGoal: false,
        };
      }
      return {
        ...state,
        isSavingGoal: false,
        config: {
          ...state.config,
          categories: state.config.categories.map((category) => {
            if (category.id !== categoryId) {
              return category;
            }
            return {
              ...category,
              metrics: category.metrics.map((metric) => {
                if (metric.id !== kpiMetricId) {
                  return metric;
                }
                return {
                  ...metric,
                  goal: kpiMetricGoal,
                };
              }),
            };
          }),
        },
      };

    case DELETE_KPI_METRIC_GOAL.REQUEST:
      return {
        ...state,
        isSavingGoal: true,
      };

    case DELETE_KPI_METRIC_GOAL.FAILURE:
      return {
        ...state,
        isSavingGoal: false,
      };

    case DELETE_KPI_METRIC_GOAL.SUCCESS:
      const deleteMeta = (action as any).meta || {};
      const { kpiMetricId: deleteMetricId, categoryId: deleteCategoryId } =
        deleteMeta;
      if (!state.config || !deleteMetricId || !deleteCategoryId) {
        return {
          ...state,
          isSavingGoal: false,
        };
      }
      return {
        ...state,
        isSavingGoal: false,
        config: {
          ...state.config,
          categories: state.config.categories.map((category) => {
            if (category.id !== deleteCategoryId) {
              return category;
            }
            return {
              ...category,
              metrics: category.metrics.map((metric) => {
                if (metric.id !== deleteMetricId) {
                  return metric;
                }
                const { goal, ...metricWithoutGoal } = metric;
                return metricWithoutGoal;
              }),
            };
          }),
        },
      };

    default:
      return state;
  }
};
